import gql from 'graphql-tag'

export const fetchSubmittedOrderDetailsQuery = gql`
  query ($orderNumber: [String])
  {
    customer {
      orders(filter: {number: {in: $orderNumber}}) {
          items {
          order_number
          id
          created_at
          grand_total
          status
          additional_data{
            summary
            free_beer_total
            delivery_date
            delivery_message
            empty_return
            ship_to_name
            sap_order_type
            total_empties_deposit
            customer_order_number
            payment_method
            total_your_price_empty_deposit
            type_of_transport
            total_your_price
            total_your_price_tax
            total_discount_basic
            total_discount_cash
            total_discount_packaging
            total_discount_promotional
            delivery_hour_from
            delivery_hour_to
            custom_email
            delivery_after_six_pm
            delivery_on_pallet
            delivery_message
            total_vat
          }            
          shipping_address {
            firstname
            lastname
            middlename
            region
            region_id
            country_code
            street
            company
            telephone
            fax
            postcode
            city
            prefix
            suffix
            vat_id
          }
          billing_address {
            firstname
            lastname
            middlename
            region
            region_id
            country_code 
          }
        }
      }
    }
  }
`
